import Box from '~/common/components/Box';
import useIsWriteAccessDisabled from '~/common/hooks/useIsWriteAccessDisabled';
import { formatDate } from '~/common/util/format';
import RentalHeader from '~/pages/IncomeCalculator/Header/RentalHeader';
import {
  isEmploymentIncome,
  isRentalIncome,
  useIncomeInformation,
} from '~/pages/IncomeCalculator/hooks';

import IncomeSourceHeader from './IncomeSourceHeader';

type IncomeHeaderProps = {
  incomeHeaderPadding?: string;
  includeCalculationHistory?: boolean;
  showForm1003ButtonInIncomeHeader?: boolean;
};

const IncomeHeader = ({
  incomeHeaderPadding,
  includeCalculationHistory,
  showForm1003ButtonInIncomeHeader = true,
}: Readonly<IncomeHeaderProps>) => {
  const { data: selectedIncome } = useIncomeInformation();
  const isWriteAccessDisabled = useIsWriteAccessDisabled();

  const props = {
    minHeight: '72px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '1px solid',
    borderColor: 'gray.100',
    padding: incomeHeaderPadding || '0 32px 0 32px',
  };

  if (isEmploymentIncome(selectedIncome)) {
    return (
      <IncomeSourceHeader
        monthlyIncome={selectedIncome.monthlyAmount}
        fullName={`${selectedIncome.borrowerName.firstName} ${selectedIncome.borrowerName.lastName}`}
        incomeCategory={selectedIncome.source}
        incomeTypes={selectedIncome.incomeTypes}
        isPrimary={selectedIncome.isPrimary}
        startDate={formatDate(selectedIncome.startDate)}
        endDate={selectedIncome.endDate && formatDate(selectedIncome.endDate)}
        isCurrent={selectedIncome.isCurrent}
        isWriteAccessDisabled={isWriteAccessDisabled}
        showForm1003ButtonInIncomeHeader={showForm1003ButtonInIncomeHeader}
        {...props}
      />
    );
  }

  if (isRentalIncome(selectedIncome)) {
    return (
      <RentalHeader
        propertyInfo={selectedIncome}
        includeCalculationHistory={includeCalculationHistory}
      />
    );
  }

  return <Box height="72px" borderBottom="1px solid" borderColor="gray.100" />;
};

export default IncomeHeader;
